module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("USAF Academy Abbreviations and Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Ac Call—Academic Call-to-Quarters, mandatory study time")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("AMI—Any Morning Inspection, usually less formal than a SAMI")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("ASAP—As Soon As Possible")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("AOC—Air Officer Commanding")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("ATO—Air Training Officer")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("AWOL—Absent Without Leave")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Blow—To rest, or to “kiss off”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Bomb—To do extremely poorly")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("BOR—Base Of the Ramp")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Buy the Farm—To crash")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Cadet Wing—The student body of USAFA cadets")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Canoe U—A small, inconsequential school (Annapolis), which forms a suburb of the capital of Maryland with a campus partly on land and partly in the Severn River")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("CCQ—Cadet in Charge of Quarters")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Clank—To freeze up; to royally goof-up")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("CDB—Commandant’s Disciplinary Board")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("CIC—Cadet In Charge")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Comm—Commandant of Cadets, a brigadier (1-star) general")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Commshop—Commandant’s office")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("CQ—used in place of CCQ")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Crash—A landing in which the vertical velocity is so great and the time spent in reducing it to zero is so brief that the acceleration and hence the forces acting become so great as to result in structural failure")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Cretin—That person ill-disposed at doing acts of nominal coordination or acts requiring minimal thought")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("DF—Dean of Faculty, a brigadier (1-star) general")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Doolie—That insignificant whose rank is measured in negative units; one whose potential for learning is unlimited; one who will graduate in some time approaching infinity")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("FIGMO—Forget It, Got My Orders")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Firstie—a First classman, a senior (cadets in their final year at the Academy)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Fourth classman—Freshman (first year cadet, known as a doolie)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("FORM 10—Cadet administrative form for documenting infraction of regulations")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("FUBAR—“Messed” Up Beyond All Recognition")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("GIB—Guy in the back seat")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Ground pounder—A non-flying officer")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Hyper—An ultra-military cadet that is focused on military bearing")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Hudson High—a small, inconsequential school (West Point) on the Hudson River distinguished by over 200 years of tradition unhampered by progress")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("IHTFP—“I Have Truly Found Paradise”; equivalently, “I Hate This Friggin’ Place”")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Intramurder—Athletic competition between squadrons; violent intramural sports")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("IRI—In Ranks Inspections")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Magic—That name applied to the department of Electrical Engineering and all related hand waving activities")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("MATS—Military Air Transport Service")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("NCOIC—Non-Commissioned Officer-in-Charge")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Nino Baldacci—That individual having entered with the class of ’59 and remaining until the present time never having been off academic probation and never having taken a privilege. He is a perpetual turn-back near and dear to all cadets.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("ODP—Off Duty Privilege")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("OIC—Officer-in-Charge")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("OTF—Over The Fence, AWOL")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("PDA—Public Display of Affection")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("PE—Physical Education")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("PFT—Physical Fitness Test")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Post—An order signifying to a subordinate that their presence is no longer needed")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Rack—Bed")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Rock—That superhuman who is free from female entanglements")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("SAC—Strategic Air Command")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("SAMI—Saturday Morning Inspection")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("SAR—Squadron Assembly Room")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("SDO—Squadron Duty Officer")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Second classman—Junior (third year cadet)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("SOD—Senior Officer of the Day")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Staff Tower—The location in the cadet dining hall (Mitchell Hall) where Wing Staff eats")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Supt—USAFA Superintendent, a lieutenant (3-star) general")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("TAC—Tactical Air Command")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("TDY—Temporary Duty")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Third classman—Sophomore (second year cadet)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Trash Hauler—Transport pilot")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Truck Driver—the pilot of a non-fighter aircraft with more than one engine (bomber or transport)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Two!—A command to return the cadet to what he or she had been doing")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("UCMJ—Uniformed Code of Military Justice")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Wing Staff—Cadre of senior cadet officers that lead the Cadet Wing")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Zoomie—That term by which a cadet is commonly known by jealous, and usually inferior, civilians")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35038beb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0008.vue
// module id = 81
// module chunks = 0